import script from "./ManagementResultTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementResultTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementResultTemplate.vue?vue&type=style&index=0&id=3d597be4&scoped=true&lang=scss"
import "./ManagementResultTemplate.vue?vue&type=style&index=1&id=3d597be4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d597be4"]])

export default __exports__